import { getConfig } from "apis/backend";
import { createGenericSlice } from "common/genericSlice";
import { getAppConfig, setAppConfig } from "services/configService";
import { handleError } from "services/errorService";

export const configSlice = createGenericSlice("config");

export const requestConfig = () => async dispatch => {
  if (getAppConfig()) return;

  try {
    dispatch(configSlice.actions.requested());
    const config = await getConfig();
    setAppConfig(config);
    dispatch(configSlice.actions.received());
  } catch (e) {
    dispatch(configSlice.actions.failed());
    handleError(e);
  }
};
